// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultDomain: 'techspark.simpliassess',

  // for UAT server devstg
  // apiUrl: 'https://uat-api.simpliassess.com/',
  // examineeApiUrl: 'https://uattest-api.simpliassess.com/',

  /////// use for  https://svaas-brazil.gatool.in/ and https://svaas.gatool.in/
  apiUrl: 'https://api-svaas.gatool.in/',
  examineeApiUrl: 'https://apitest-svaas.gatool.in/',

/////// use for  https://col.easygatool.com/ and https://br.easygatool.com/#
  // apiUrl: 'https://api.easygatool.com/',
  // examineeApiUrl: 'https://delivery.easygatool.com/',

  /////// use for  https://drr.simpliassess.com/ and https://br.simpliassess.com/ and https://col.simpliassess.com/
  // apiUrl: 'https://drr-api.simpliassess.com/',
  // examineeApiUrl: 'https://drrtest-api.simpliassess.com/',

  // apiUrl: 'http://tad.tanayassessmentdev.com/',
  // examineeApiUrl: 'http://tdd.tanayassessmentdev.com/',

  // apiUrl: 'https://ms13.simpliassess.com/',
  // examineeApiUrl: 'https://ms13.simpliassess.com/',

  //ai
  aiApiUrl: 'http://sandbox.simpliassess.com/demo/item-generator/',

  userName: 'demo@simpliassess.com',
  password: 'AIin2023',

  // 32-character shared secret for AES-256-CBC login credential encryption
  aesEncryptionKey: 'N3w#era98a4e4133bbce2ea23N3w#era',

  // Log API
  logApiUrl: 'https://exceplogs.simpliassess.com/',


  // Azure cognitive speech tool
  SPEECH_KEY: 'bd751d93603d40a5aee13bd359bf4415',
  SPEECH_REGION: 'westus2',
  SPEECH_VOICE_NAME: 'en-US-AshleyNeural'
};

// for production
// apiUrl: 'http://ta-api.simpliassess.com/',
// examineeApiUrl: 'http://td-api.simpliassess.com/'

//for dev server ---  dev server
// apiUrl: 'http://tad.tanayassessmentdev.com/',
// examineeApiUrl: 'http://tdd.tanayassessmentdev.com/'

//  apiUrl: 'http://microservice.tanayassessmentdev.com/admin-service/',
//  examineeApiUrl: 'http://microservice.tanayassessmentdev.com/delivery-service/'

//for tanay server
// apiUrl: 'http://tad.tanayasses   nayassessmentdev.com/'
//  apiUrl: 'http://server1:8081/',
// examineeApiUrl: 'http://server1:8082/'

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
